import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: "Código Solicitud",
        field: "solicitud",
        sort: "asc"
    },
    {
        label: "Solicitante",
        field: "solicitante",
        sort: "asc"
    },
    {
        label: "Titulo",
        field: "titulo",
        sort: "asc"
    },
    {
        label: "Fecha de Configuración",
        field: "fecha_creacion",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estadoA",
        sort: "asc"
    },
    {
        label: "Acciones",
        field: "accion",
        width: 100
    }
];
export default class listaConcurrente extends React.Component {

    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);

        this.state = {
            tabla: { columns: columns, rows: [] },

            filtros: {
                departamento: undefined
            },

            lista: [],
            listaDepartamento: [],
            modalAbierto: false,
            idRegistroEliminar: null,
            filtros2: {
                departamento: undefined
            }
        }
        this.obtenerValorSelect = this.obtenerValorSelect.bind(this);
        this.buscar = this.buscar.bind(this);
        this.desactivar = this.desactivar.bind(this);
    }

    componentDidMount() {
        this.getDepartamento();
    }

    getDepartamento = () => {
        this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ listaDepartamento: this.formatoDepartamento(resultado) })
            }
        });
    }

    formatoDepartamento = valores => valores.data.map(i => ({ value: i.value, label: i.label }));

    obtenerValorSelect = (e) => {

        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['departamento']: e }
        }));

        if(_valid(e)){
            this.setState(estadoAnterior => ({
                filtros2: { ...estadoAnterior.filtros2, ['departamento']: e }
            }));
        }
    }

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.accion = this.botonesListado(registro));
        return { columns, rows };
    };

    desactivar = (registro) => {
        this.apiRest.get('/desactivarSolicitud/' + registro.id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tabla: this.agregarAccionesRegistro(resultado.data) })
                toastr.success('Registro desactivado exitosamente!');
            }
        });
    }

    botonesListado = (registro) => [
        <MDBBtn className="waves-effect" size="sm" color="danger" title="Eliminar Solicitud Automatica" onClick={() => this.mostrarModalEliminar(registro.id)}>
            <MDBIcon icon="fa fa-eraser" />
        </MDBBtn>
        , ' ',
        <MDBBtn className="waves-effect" size="sm" color="danger" title="Desactivar Solicitud Automatica" onClick={() => this.desactivar(registro)}>
            <MDBIcon icon="fas fa-power-off" />
        </MDBBtn>
    ];

    eliminarRegistro = idRegistro => {
        const{
            filtros2
        } = this.state;

        this.apiRest.delete('/eliminarConcurrencia/' + idRegistro).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Registro eliminado exitosamente!');
                this.ocultarModalEliminar();
                if(_valid(filtros2)){
                    this.buscar2();
                }
            }
        });
    }

    ocultarModalEliminar = () => {
        this.setState({ modalAbierto: false, idRegistroEliminar: null });
    }

    mostrarModalEliminar = idRegistro => {
        this.setState({ modalAbierto: true, idRegistroEliminar: idRegistro });
    }

    buscar = () => {
        const {
            filtros
        } = this.state;

        this.apiRest.post('/solicitudConcurrente_list_departamento', filtros).then(resultado => {
            if (resultado.exitoso) {
                //console.log(resultado.data);
                this.setState({ tabla: this.agregarAccionesRegistro(resultado.data) })
            } else {
                toastr.error(resultado.mensaje);
            }
        });
    }

    buscar2 = () => {
        const {
            filtros2
        } = this.state;

        this.apiRest.post('/solicitudConcurrente_list_departamento', filtros2).then(resultado => {
            if (resultado.exitoso) {
                //console.log(resultado.data);
                this.setState({ tabla: this.agregarAccionesRegistro(resultado.data) })
            } else {
                toastr.error(resultado.mensaje);
            }
        });
    }

    render() {
        const {
            filtros,
            listaDepartamento,
            tabla
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem={this.titulo} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <p />
                                    <Row className="align-items-center justify-content-center">
                                        <span className="text-center"><strong>{'Lista de Solicitudes Concurrentes'}</strong></span>
                                    </Row>
                                    <CardBody>
                                        <Row>
                                            <Col lg={3}>
                                                <Label htmlFor="fechaInicio" className="form-label">
                                                    Departamento/Área
                                                </Label>
                                                <Select
                                                    name="departamento"
                                                    options={listaDepartamento}
                                                    value={filtros.departamento}
                                                    onChange={this.obtenerValorSelect}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Seleccionar"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "No hay más opciones"}
                                                />
                                            </Col>

                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={3}>
                                                <MDBBtn className="waves-effect" color="success" onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <p />
                                        <div className="table-responsive">
                                            <MDBDataTable
                                                keyField="id"
                                                hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]}
                                                noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]}
                                                entriesLabel="Mostrando entradas" data={tabla}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAbierto} size="mm">
                    <ModalHeader>
                        Eliminar Registro
                    </ModalHeader>
                    <ModalBody>
                        Esta seguro?
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="danger" onClick={() => this.eliminarRegistro(this.state.idRegistroEliminar)}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Eliminar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalEliminar()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}